export const MICROHABIT_SIMPLE_TYPE = 1
export const MICROHABIT_FOOD_TYPE = 2

export const MICROHABIT_TYPES = [
	MICROHABIT_SIMPLE_TYPE,
	MICROHABIT_FOOD_TYPE
]

export const MICROHABIT_TYPE_NAMES = {
	[MICROHABIT_SIMPLE_TYPE]: 'microhabits',
	[MICROHABIT_FOOD_TYPE]: 'foods'
}

export default {
	MICROHABIT_SIMPLE_TYPE,
	MICROHABIT_FOOD_TYPE
}


// WEBPACK FOOTER //
// ./src/constants/microhabitTypes.js